import { TAGDialog } from '@aspendental/shared-components-web';
import Button from '@mui/material/Button';
import { useTranslation } from 'next-i18next';

import FurtherAssistanceContact from '../FurtherAssistanceContact';

import { useGlobalUXStore } from '@src/store';

export default function GlobalDialog() {
	const { dialogOpen, setDialogOpen, errorMessage } = useGlobalUXStore((store) => store);
	const { t } = useTranslation('globalDialog');

	return (
		<TAGDialog
			open={dialogOpen}
			handleClose={() => setDialogOpen(false)}
			title={errorMessage}
			renderTextContent={() => <FurtherAssistanceContact directAction />}
			renderActions={() => (
				<Button variant="tertiaryDefault" onClick={() => setDialogOpen(false)} size="M">
					{t('dismiss')}
				</Button>
			)}
		/>
	);
}
